import { Button, Modal, Row, Space } from 'antd';
import React from 'react';
import { Props, DataType } from './types';
import TableSort from '../../../../../components/TableSort';
import { ColumnType } from 'antd/lib/table';
import Status from '../../../../../components/GetStatus';
import { maskCapitalized } from '../../../../../utils/mask';
import moment from 'moment';
import api from '../../../../../service/api';
import { SKW_PREFIX } from '../../../../../utils/constants';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import Swal from 'sweetalert2';
import ModalConversation from '../../../../atendimento/Modal/Conversation';
import { PrinterOutlined } from '@ant-design/icons';
import ExportBtn from '../../../../../components/ExportBtn';
import { ExportBtnProps } from '../../../../atendimento/types';
import saveAs from 'file-saver';

const App: React.FC<Props> = ({ isModalOpen, setIsModalOpen, protocolos }) => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<DataType[]>([]);

  React.useEffect(() => {
    if (isModalOpen && protocolos.length > 0) {
      setLoading(true);
      api
        .post(`call?serviceName=${SKW_PREFIX}getOcorrencias&token=${token}`, {
          listaProtocolos: protocolos,
        })
        .then((response) => {
          setData(response.data?.ocorrencias);
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Erro ao carregar os dados!',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [isModalOpen, protocolos, token]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns: ColumnType<DataType>[] = [
    {
      title: 'Abrir ocorrência',
      key: 'lido',
      dataIndex: 'lido',
      width: 150,
      align: 'center',

      render: (lido, data, index) => {
        return <ModalConversation propriedades={data} />;
      },
    },
    {
      title: 'Protocolo',
      key: 'protocolo',
      dataIndex: 'protocolo',
      width: 100,
      align: 'center',

      render: (protocolo, data, index) => {
        return protocolo.toString().padStart(6, '0');
      },
    },

    {
      title: 'CD',
      key: 'cd',
      dataIndex: 'cd',
      width: 220,
      align: 'center',

      render: (cd, data, index) => {
        return maskCapitalized(cd);
      },
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 220,
      align: 'center',

      render: (text) => {
        return text ? <Status acronym={text} /> : 'Não identificado';
      },
    },

    {
      title: 'Data da abertura',
      key: 'dtAbertura',
      dataIndex: 'dhAbertura',
      width: 180,

      render(dhAbertura, data, index) {
        return dhAbertura ? moment(dhAbertura).format('lll') : 'Sem data de abertura';
      },
    },

    {
      title: 'Atendente',
      key: 'atendente',
      dataIndex: 'atendente',
      width: 150,
      render(atendente, data, index) {
        return atendente ? atendente : 'Sem atendente selecionado';
      },
    },

    {
      title: 'Parceiro',
      key: 'parceiro',
      dataIndex: 'parceiro',
      width: 300,

      render(parceiro, data, index) {
        return parceiro ? maskCapitalized(parceiro) : 'Sem parceiro';
      },
    },

    {
      title: 'Embarcador',
      key: 'embarcador',
      dataIndex: 'embarcador',
      width: 300,

      render(embarcador, data, index) {
        return embarcador ? maskCapitalized(embarcador) : 'Sem embarcador';
      },
    },
  ];

  const exportData: ExportBtnProps[] = data?.map((item: any) => {
    let status;
    switch (item.status) {
      case 'AA':
        status = 'Aguardando atendimento';
        break;
      case 'EA':
        status = 'Em atendimento';
        break;
      case 'AC':
        status = 'Atendimento finalizado';
        break;
      default:
        status = '';
        break;
    }
    return {
      Protocolo: item.protocolo,
      'Tipo de solicitação': item.tipoSolicitacao,
      'Classificação de urgência': item.urgencia,
      Status: status,
      Parceiro: item.parceiro,
      'N° da(s) nota(s)': item.listaNf,
      'Data da abertura': item.dtAbertura,
      'Data da conclusão': item.dtConclusao,
      Assunto: item.assunto,
      Embarcador: item.embarcador,
      Atendente: item.atendente,
    };
  });

  const handlePdf = () => {
    api
      .post(
        `/call?serviceName=${SKW_PREFIX}imprimeAtendimentos&token=${token}`,
        { listaProtocolos: protocolos },
        {
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        saveAs(blob, 'atendimentos.pdf');
      });
  };

  return (
    <>
      <Modal
        title={<h3>Ocorrências</h3>}
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1200}
        footer={null}
      >
        <TableSort
          columns={columns}
          scroll={{ x: 1500 }}
          dataSource={data}
          size={'large'}
          style={{ fontSize: 10, display: 'inline' }}
          pagination={false}
          loading={loading}
        />
        <Row gutter={24} justify="end">
          <Space style={{ margin: '20px 10px' }}>
            <Button type="link" onClick={() => handlePdf()}>
              <PrinterOutlined /> Imprimir
            </Button>
            <ExportBtn data={exportData} filename={'tracking'} />
          </Space>
        </Row>
      </Modal>
    </>
  );
};

export default App;
